import * as React from "react";
const Windows10Wifi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M6.65 7.35c2.018-2.148 5.107-3.412 8-3.5v-1c-3.338.101-6.677 1.028-9 3.5-2.323 2.471-3.104 5.162-3 8.5h1c-.09-2.894.98-5.354 3-7.5Zm8 1.5c-3.621.11-6.112 2.379-6 6h1c-.084-2.718 2.282-4.917 5-5v-1Z"
    />
    <path
      fill="#fff"
      d="M14.65 5.85c-5.387.164-9.168 3.613-9 9h1c-.139-4.485 3.515-7.863 8-8v-1ZM13.15 14.85a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>
);
export default Windows10Wifi;
